var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshot5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.094 26.9984C17.1053 25.9088 17.3908 24.8397 17.9238 23.8912C19.0471 21.8924 21.2043 20.6232 23.4851 20.6181C25.7658 20.6232 27.9231 21.8924 29.0464 23.8912C29.5793 24.8397 29.8648 25.9088 29.8761 26.9984M15.6274 21.3512L13.5665 23.6162C13.0792 24.0756 12.4185 24.3337 11.7297 24.3337C11.0409 24.3337 10.3802 24.0756 9.8929 23.6162L4.37798 18.4133C2.92418 17.0414 1.93414 15.2934 1.53306 13.3905C1.13198 11.4876 1.33788 9.51516 2.12472 7.72267C2.91156 5.93018 4.24401 4.39812 5.95356 3.32022C7.66311 2.24232 9.67298 1.66699 11.729 1.66699C13.7851 1.66699 15.795 2.24232 17.5045 3.32022C19.2141 4.39812 20.5465 5.93018 21.3333 7.72267M23.4851 19.7872C25.5433 19.7872 27.2117 18.1186 27.2117 16.0604C27.2117 14.0022 25.5433 12.3337 23.4851 12.3337C21.4269 12.3337 19.7584 14.0022 19.7584 16.0604C19.7584 18.1186 21.4269 19.7872 23.4851 19.7872ZM7.83065 11.4765C7.83065 12.4522 8.24137 13.3879 8.97246 14.0777C9.70354 14.7676 10.6951 15.1552 11.729 15.1552C12.7629 15.1552 13.7545 14.7676 14.4856 14.0777C15.2167 13.3879 15.6274 12.4522 15.6274 11.4765C15.6274 10.5009 15.2167 9.56516 14.4856 8.87527C13.7545 8.18538 12.7629 7.79781 11.729 7.79781C10.6951 7.79781 9.70354 8.18538 8.97246 8.87527C8.24137 9.56516 7.83065 10.5009 7.83065 11.4765Z",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot5);
export default __webpack_public_path__ + "static/media/snapshot5.57793dda2545c1d0d9c33dce879e1d0c.svg";
export { ForwardRef as ReactComponent };